import {useState} from "react";

const ContactUs = props => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const handleSend = (e) => {
        e.preventDefault();
        fetch('https://api.smtp.bz/v1/smtp/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': '4dniwmg2jbF6NfdYZkFz7RG6ebNQFAuzEHI1',
            },
            body: JSON.stringify({
                "name": "Контакт360",
                "from": "info@globalb2b.ru",
                "to": "vmv@yourtar.ru",
                "subject": "Заявка на подключение Контакт360",
                "html": "<html><head></head><body><p>Имя: " + name + "</p><p>Телефон: " + phone + "</p><p>Мыло: " + email + "</p></body></html>"
            })
        }).then(res => res.json()).then(result => {
            alert('Ваша заявка принята! Мы свяжемся с Вами в ближайшее время!')
        })
    }

    return <section className="contact section" id="contacts">
        <div className="container contact-card">
            <div className="contact-copy">
                <p className="eyebrow">Следующий шаг</p>
                <h2>Свяжитесь с нами</h2>
                <p>Оставьте свои контакты, и мы свяжемся с Вами в ближайшее время, чтобы обсудить потенциал
                    Вашей клиники.</p>
                <div className="headset" aria-hidden="true">◯</div>
            </div>

            <form className="contact-form" id="contactForm" onSubmit={handleSend}>
                <label>ФИО<input onChange={e => setName(e.target.value)} type="text" name="name" autoComplete="name" required
                                 placeholder="ФИО"/></label>
                <label>Телефон<input onChange={e => setPhone(e.target.value)} type="tel" name="phone" autoComplete="tel" required
                                     placeholder="+7 (___) ___-__-__"/></label>
                <label>Email<input  onChange={e => setEmail(e.target.value)} type="email" name="email" autoComplete="email" placeholder="Email"/></label>
                <button className="button button-primary" type="submit" onClick={handleSend}>Свяжитесь со мной</button>
                <p className="form-message" id="formMessage" role="status"></p>
            </form>
        </div>
    </section>
}

export default ContactUs